export const imageExtensions = ["png", "jpg", "jpeg", "gif", "heic", "heif"];

export const excelFormats = ["xls", "xlsx"];
export const documentFormats = ["doc", "docx"];

export const excelFileType =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export const documentExtensions = [...excelFormats, "pdf", "doc", "docx"];
